export const UserLoginLogsConstants= {
 
    GET_USERLOGINLOGS_REQUEST: 'GET_USERLOGINLOGS_REQUEST',
    GET_USERLOGINLOGS_SUCCESS: 'GET_USERLOGINLOGS_SUCCESS',
    GET_USERLOGINLOGS_FAILURE: 'GET_USERLOGINLOGS_FAILURE',
}